export default "__VITE_ASSET__s_7oPrEF__"